import { Place, PlaceClassification } from '~/models/Place'
import { ApiPlace } from './apiTypes'
import { Spot2 } from '~/models/Spot'

export class BackendPlaceEntityMapper {
	static toPlace(apiPlace: ApiPlace, spot?: Spot2): Place {
		let type = 'touristAttraction'
		if (apiPlace.types[0] && this.googlePlaceTypeToCategory[apiPlace.types[0]]) {
			type = this.googlePlaceTypeToCategory[apiPlace.types[0]]!
		}
		const place: Place = {
			id: apiPlace.place_id,
			name: apiPlace.name,
			address: apiPlace.address,
			type,
			images: apiPlace.photos_urls,
			rating: apiPlace.rating,
			cover: apiPlace.photos ? apiPlace.photos[0] : '',
			phone: apiPlace.phone_number,
			mapUrl: apiPlace.map_url,
			website: apiPlace.website || '',
			schedule: apiPlace.schedule,
			location: apiPlace.location,
		}
		if (spot?.description) place.description = spot.description
		if (spot?.cover) place.images = [spot.cover, ...apiPlace.photos_urls]

		return place
	}

	private static googlePlaceTypeToCategory: Record<string, PlaceClassification> = {
		adventure_sports_center: 'touristAttraction',
		airport: 'airport',
		airstrip: 'airport',
		amusement_park: 'touristAttraction',
		aquarium: 'touristAttraction',
		art_gallery: 'culture',
		auditorium: 'culture',
		auto_parts_store: 'shopping',
		bagel_shop: 'food',
		bakery: 'food',
		bar: 'drink',
		barber_shop: 'service',
		beach: 'outdoorLocation',
		beauty_salon: 'service',
		bed_and_breakfast: 'accommodation',
		book_store: 'shopping',
		botanical_garden: 'outdoorLocation',
		breakfast_restaurant: 'food',
		brunch_restaurant: 'food',
		bus_station: 'transport',
		bus_stop: 'transport',
		cafe: 'food',
		campground: 'accommodation',
		camping_cabin: 'accommodation',
		candy_store: 'food',
		casino: 'touristAttraction',
		cat_cafe: 'drink',
		child_care_agency: 'service',
		chinese_restaurant: 'food',
		chiropractor: 'service',
		clothing_store: 'shopping',
		coffee_shop: 'drink',
		concert_hall: 'touristAttraction',
		convenience_store: 'shopping',
		cottage: 'accommodation',
		courier_service: 'service',
		cultural_center: 'culture',
		cultural_landmark: 'culture',
		cycling_park: 'outdoorLocation',
		deli: 'food',
		dentist: 'service',
		department_store: 'shopping',
		doctor: 'service',
		dog_cafe: 'drink',
		dog_park: 'outdoorLocation',
		donut_shop: 'food',
		electrician: 'service',
		electronics_store: 'shopping',
		event_venue: 'touristAttraction',
		extended_stay_hotel: 'accommodation',
		farmstay: 'accommodation',
		fast_food_restaurant: 'food',
		ferry_terminal: 'transport',
		fishing_charter: 'outdoorLocation',
		fishing_pond: 'outdoorLocation',
		food_store: 'food',
		french_restaurant: 'food',
		funeral_home: 'service',
		furniture_store: 'shopping',
		garden: 'outdoorLocation',
		gift_shop: 'shopping',
		grocery_store: 'shopping',
		guest_house: 'accommodation',
		hair_salon: 'service',
		hardware_store: 'shopping',
		heliport: 'airport',
		hiking_area: 'outdoorLocation',
		historical_landmark: 'culture',
		historical_place: 'culture',
		home_goods_store: 'shopping',
		hostel: 'accommodation',
		hotel: 'accommodation',
		ice_cream_shop: 'food',
		indian_restaurant: 'food',
		inn: 'accommodation',
		insurance_agency: 'service',
		international_airport: 'airport',
		italian_restaurant: 'food',
		japanese_inn: 'accommodation',
		japanese_restaurant: 'food',
		jewelry_store: 'shopping',
		juice_shop: 'drink',
		korean_restaurant: 'food',
		lawyer: 'service',
		light_rail_station: 'transport',
		liquor_store: 'shopping',
		locksmith: 'service',
		lodging: 'accommodation',
		market: 'shopping',
		massage: 'service',
		meal_delivery: 'food',
		meal_takeaway: 'food',
		mediterranean_restaurant: 'food',
		mexican_restaurant: 'food',
		mobile_home_park: 'accommodation',
		monument: 'culture',
		motel: 'accommodation',
		museum: 'culture',
		nail_salon: 'service',
		national_park: 'outdoorLocation',
		observation_deck: 'touristAttraction',
		opera_house: 'culture',
		painter: 'service',
		park: 'outdoorLocation',
		park_and_ride: 'transport',
		performing_arts_theater: 'culture',
		pet_store: 'shopping',
		philharmonic_hall: 'culture',
		picnic_ground: 'outdoorLocation',
		pizza_restaurant: 'food',
		planetarium: 'culture',
		playground: 'outdoorLocation',
		plumber: 'service',
		private_guest_room: 'accommodation',
		psychic: 'service',
		pub: 'drink',
		real_estate_agency: 'service',
		resort_hotel: 'accommodation',
		restaurant: 'food',
		roller_coaster: 'touristAttraction',
		rv_park: 'accommodation',
		sauna: 'service',
		sculpture: 'culture',
		seafood_restaurant: 'food',
		shoe_store: 'shopping',
		shopping_mall: 'shopping',
		skateboard_park: 'outdoorLocation',
		spa: 'service',
		sporting_goods_store: 'shopping',
		sports_complex: 'outdoorLocation',
		state_park: 'outdoorLocation',
		steak_house: 'food',
		storage: 'service',
		store: 'shopping',
		subway_station: 'transport',
		supermarket: 'shopping',
		sushi_restaurant: 'food',
		taxi_stand: 'transport',
		tea_house: 'drink',
		telecommunications_service_provider: 'service',
		thai_restaurant: 'food',
		tourist_attraction: 'touristAttraction',
		train_station: 'transport',
		transit_depot: 'transport',
		transit_station: 'transport',
		travel_agency: 'service',
		truck_stop: 'transport',
		vegan_restaurant: 'food',
		vegetarian_restaurant: 'food',
		veterinary_care: 'service',
		warehouse_store: 'shopping',
		wedding_venue: 'touristAttraction',
		wellness_center: 'service',
		wildlife_park: 'outdoorLocation',
		wildlife_refuge: 'outdoorLocation',
		wine_bar: 'drink',
		zoo: 'touristAttraction',
	}
}
